import { FC, ReactElement } from 'react';
import { Navigate } from 'react-router-dom';
import { useStore } from '@hooks/useStore';
import { AuthSessionGate } from './AuthSessionGate';
import { canAccessMeetings } from '@/utils/auth/canAccessMeetings';

export interface MeetingsProtectedProps {
  element: ReactElement | null;
}

const MeetingsProtected: FC<MeetingsProtectedProps> = ({ element }) => {
  const { authStore } = useStore();
  const hasAccess = canAccessMeetings(authStore);

  return (
    <AuthSessionGate>
      {hasAccess ? element : <Navigate to="/dashboard" replace />}
    </AuthSessionGate>
  );
};

export default MeetingsProtected;
